/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-tablo-bord-messagerie': {
    width: 74.4,
    height: 66.1,
    viewBox: '0 136 74.4 66.1',
    data: '<path pid="0" d="M37.2 136C16.7 136 0 149 0 165c0 6.3 2.7 12.5 7.5 17.5l-3.1 19.6 23.4-9c3 .601 6.2.9 9.4.9 20.5 0 37.2-13 37.2-29s-16.7-29-37.2-29m0 53.6c-3.1 0-6.2-.3-9.1-1l-.6-.1-17.5 6.8 2.2-14.3-.8-.8c-4.6-4.4-7-9.601-7-15.2 0-13.6 14.7-24.6 32.8-24.6 18.1 0 32.8 11.1 32.8 24.6 0 13.6-14.7 24.6-32.8 24.6"/>'
  }
})
